module.exports = __webpack_public_path__ + "img/section7-4.f777912d.svg";